import React from 'react';
import styles from './faceMatchingResponse.module.scss';
import { FaceMatchingResponseData } from '@models/prediction';
import classNames from 'classnames';
import Response from '@components/result';
import { IconFaceVerified } from '@yoti/ui-kit-components-react/globals';

interface Props {
    responseData?: FaceMatchingResponseData;
}

export const FaceMatchingResponse: React.FC<Props> = (props) => {
    const { responseData } = props;

    const { score, errorCode, errorMessage } = responseData || {};

    return (
        <Response
            errorCode={errorCode}
            errorMessage={errorMessage}
            data-qa="face-matching-response"
        >
            {score && (
                <>
                    <IconFaceVerified className={styles['response__icon']} />
                    <span
                        className={classNames(
                            styles['response__text'],
                            styles['response__text--bold'],
                        )}
                        data-qa="matching-score"
                    >{`Matching score: `}</span>
                    {score}
                </>
            )}
        </Response>
    );
};

export default FaceMatchingResponse;
